import {fetchApiClient} from "common/fetchApiClient";
import {API_URL} from "common/const";
import UnauthorizedError from "api/errors/UnauthorizedError";
import { AxiosError } from "axios";
import User from "model/User";


const removePenalty = async (user: User, competitionCode: string, leagueId: number, token: string | undefined): Promise<void> => {
    const apiClient = fetchApiClient(token);

    await apiClient.delete(`${API_URL}/penalties/${competitionCode}/${leagueId}/${user.uid}`)
    .catch((error: AxiosError) => {
        console.log(`Error removing penalty`, competitionCode, leagueId, user.uid, error);
        if (!!error.response && error.response.status === 403) {
            throw new UnauthorizedError();
        }
        throw error;
    });
}

export default removePenalty;
